import React, { useState } from 'react';
import { CheckCircle2, ChevronRight, AlertCircle, Flame } from 'lucide-react';
import { SectionHeader, Button } from '../ui/Shared';
const QUESTIONS = [{
  id: 1,
  question: '¿Con qué frecuencia sientes ardor o acidez en el pecho por la noche?',
  options: ['Casi todas las noches', '2-3 veces por semana', 'Rara vez']
}, {
  id: 2,
  question: '¿Sientes un "nudo" en la garganta o sabor amargo al despertar?',
  options: ['Sí, frecuentemente', 'Solo a veces', 'No, nunca']
}, {
  id: 3,
  question: '¿Dependes de pastillas (como omeprazol) para poder comer o dormir tranquilo?',
  options: ['Sí, a diario', 'Solo cuando como pesado', 'No tomo pastillas']
}];
export function SymptomQuizSection() {
  const [currentStep, setCurrentStep] = useState(0);
  const [answers, setAnswers] = useState<number[]>([]);
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const handleAnswer = (optionIndex: number) => {
    const newAnswers = [...answers, optionIndex];
    setAnswers(newAnswers);
    if (currentStep < QUESTIONS.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      // Finish quiz
      setIsAnalyzing(true);
      setTimeout(() => {
        setIsAnalyzing(false);
        setShowResult(true);
      }, 1500);
    }
  };
  const resetQuiz = () => {
    setCurrentStep(0);
    setAnswers([]);
    setShowResult(false);
  };
  return <section id="quiz" className="py-24 bg-surface relative overflow-hidden" data-id="element-353">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-accent/5 rounded-full blur-[100px] pointer-events-none" data-id="element-354" />

      <div className="max-w-[780px] mx-auto px-6 relative z-10" data-id="element-355">
        <SectionHeader tag="Evaluación rápida" title="¿En qué fase de daño está tu esófago?" subtitle="Responde 3 preguntas rápidas para descubrir si Reflujo Cero en 72h funcionará para tu caso específico." data-id="element-356" />

        <div className="mt-12 bg-secondary border border-white/10 rounded-2xl p-6 md:p-10 shadow-2xl relative min-h-[350px] flex flex-col justify-center" data-id="element-357">
          {!isAnalyzing && !showResult && <div className="animate-[fadeIn_0.4s_ease-out]" data-id="element-358">
              <div className="flex justify-between items-center mb-8" data-id="element-359">
                <span className="text-sm font-bold text-accent uppercase tracking-wider" data-id="element-360">
                  Pregunta {currentStep + 1} de {QUESTIONS.length}
                </span>
                <div className="flex gap-1.5" data-id="element-361">
                  {QUESTIONS.map((_, idx) => <div key={idx} className={`h-1.5 rounded-full transition-all duration-300 ${idx <= currentStep ? 'w-6 bg-accent' : 'w-2 bg-white/10'}`} data-id="element-362" />)}
                </div>
              </div>

              <h3 className="text-xl md:text-2xl font-bold text-text-light mb-8 leading-tight" data-id="element-363">
                {QUESTIONS[currentStep].question}
              </h3>

              <div className="space-y-3" data-id="element-364">
                {QUESTIONS[currentStep].options.map((option, idx) => <button key={idx} onClick={() => handleAnswer(idx)} className="w-full text-left p-4 rounded-xl border border-white/5 bg-surface hover:bg-white/5 hover:border-accent/30 transition-all duration-200 flex items-center justify-between group" data-id="element-365">
                    <span className="text-text-light font-medium" data-id="element-366">
                      {option}
                    </span>
                    <ChevronRight className="w-5 h-5 text-text-muted group-hover:text-accent transition-colors" data-id="element-367" />
                  </button>)}
              </div>
            </div>}

          {isAnalyzing && <div className="flex flex-col items-center justify-center text-center py-10 animate-[fadeIn_0.4s_ease-out]" data-id="element-368">
              <div className="w-16 h-16 border-4 border-accent/20 border-t-accent rounded-full animate-spin mb-6" data-id="element-369" />
              <h3 className="text-xl font-bold text-text-light mb-2" data-id="element-370">
                Analizando tus respuestas...
              </h3>
              <p className="text-text-muted" data-id="element-371">
                Evaluando el nivel de acidez y daño en la mucosa.
              </p>
            </div>}

          {showResult && <div className="text-center animate-[fadeIn_0.5s_ease-out]" data-id="element-372">
              <div className="w-20 h-20 bg-danger/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-373">
                <AlertCircle className="w-10 h-10 text-danger" data-id="element-374" />
              </div>

              <h3 className="font-playfair text-2xl md:text-3xl font-black text-text-light mb-4" data-id="element-375">
                Tu barrera mucosa está comprometida
              </h3>

              <p className="text-base text-text-muted leading-relaxed mb-8 max-w-[500px] mx-auto" data-id="element-376">
                Basado en tus respuestas, tu cuerpo ha perdido su capacidad
                natural de neutralizar el ácido. Si no actúas ahora, el daño en
                tu esófago podría volverse irreversible.
                <strong className="text-text-light block mt-2" data-id="element-377">
                  Reflujo Cero en 72h está diseñado exactamente para revertir
                  este nivel de daño.
                </strong>
              </p>

              <div className="flex justify-center" data-id="element-378">
                <button onClick={resetQuiz} className="text-sm text-text-muted hover:text-text-light transition-colors underline underline-offset-4" data-id="element-379">
                  Volver a hacer el test
                </button>
              </div>
            </div>}
        </div>
      </div>
    </section>;
}